export default __webpack_public_path__ + "static/media/defaultPerson.361a323a.svg";